import React from 'react';

interface Props {
  icon?: string;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
  action2?: { label: string; onClick: () => void };
}

export default function EmptyState({ icon = '📋', title, description, action, action2 }: Props) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-8 text-center bg-white rounded-2xl border">
      <div className="text-5xl mb-4">{icon}</div>
      <h3 className="text-lg font-bold text-gray-800 mb-2">{title}</h3>
      {description && <p className="text-sm text-gray-400 max-w-sm mb-6">{description}</p>}
      {(action || action2) && (
        <div className="flex gap-3">
          {action && (
            <button onClick={action.onClick}
              className="px-5 py-2.5 rounded-xl text-white font-semibold text-sm"
              style={{ background: 'linear-gradient(135deg,#02357A,#015CA6)' }}>
              {action.label}
            </button>
          )}
          {action2 && (
            <button onClick={action2.onClick}
              className="px-5 py-2.5 rounded-xl border text-gray-600 font-medium text-sm hover:bg-gray-50">
              {action2.label}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
